export default __webpack_public_path__ + "static/media/firebase.dbce7741.svg";